/** Shared scene coordinates, independent of artwork and catalog resolution. */
export const BLOCK_WIDTH = 2400;
export const SCENE_HEIGHT = 760;
export const STREET_Y = 600;
